export default __webpack_public_path__ + "static/media/LogoTransparent.ace18aca.png";